export default __webpack_public_path__ + "static/media/home_screen.1bc24ebd.svg";